export { default, default as TagNew, colorMapping } from './tag-new';

export { default as AvatarTag } from './avatar-tag';

export { default as TagDropdownTrigger } from './tag-dropdown-trigger';
export type { AvatarTagProps, AvatarRenderProps, TypesOfAvatars } from './avatar-tag';
export type { NewTagColor, TagDropdownTriggerProps, TagNewProps } from './types';
